import React, { useState } from 'react';
import {
  Image,
  FrameSvg,
} from '../common';
import './ImageGallery.scss';

const ImageGallery = (props) => {
  const {
    images,
    highlightColourHex,
  } = props;
  const [activeImage, setActiveImage] = useState(0);
  if (!images || images.length < 1) return null;
  const noOptions = (images.length === 1);
  return (
    <div className={`image-gallery${noOptions ? ' no-options' : ''}`}>
      <div className="cols">
        { !noOptions && (
          <div className="col col-left">
            <ul className="image-options">
              {images.map((image, index) => (
                <li
                  className={`image-option${activeImage === index ? ' active' : ''}`}
                  key={image.id}
                >
                  <button
                    type="button"
                    className="image-selector"
                    onClick={() => setActiveImage(index)}
                    aria-label="Focus on this image"
                  >
                    <Image image={image} />
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
        <div className="col col-right">
          <div className="focussed-image">
            <div className="image-container">
              <FrameSvg frameHex={highlightColourHex} />
              <Image image={images[activeImage]} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageGallery;
